import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getCurrentUser, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
    providedIn: 'root'
})
export class MainService {

    endpoint: string = getEndpoint('ADMIN_CAJEROS')
    // endpoint = 'http://127.0.0.1:8000/appventas/admin/cajeros/v1/:company'




    constructor(private requestsService: RequestsService) { }
    async findRegister(inactivos, page, size, store = ''): Promise<BasicResponse> {
        console.log(store)
        let params_store = ""
        if (store != "") {
            params_store = `&agencia=${store}`
        }
        const url = this.endpoint.replace(':company', getConnection()) + `/list_cajeros` + `?estado=${inactivos}&size=${size}&page=${page}&agencia=${store}`
        const result = await this.requestsService.get(url);
        return result
    }

    async findStores(codigo): Promise<BasicResponse> {
        const url = this.endpoint.replace(':company', getConnection()) + `/${codigo}/list_stores_cajero`
        const result = await this.requestsService.get(url);
        return result
    }

    // async assingStore(codigo){
    //     const 
    // }

    async create(codigo, doc, des, usuario, age, est, tipo, cajarap, t_cajero): Promise<BasicResponse> {
        const url = this.endpoint.replace(':company', getConnection()) + `/newcajero`
        const result = await this.requestsService.postLikeJSON(url, {
            codigo, doc, des, usuario, age, est, tipo, cajarap, t_cajero, usuario_crea: getCurrentUser().usuario_aplicativo
        });
        return result
    }

    async update(codigo, tienda, cajarap, t_cajero, estado): Promise<BasicResponse> {
        const url = this.endpoint.replace(':company', getConnection()) + `/edit_cajero`
        const result = await this.requestsService.putLikeJSON(url, {
            codigo: codigo, cajarap: cajarap, age: tienda, t_cajero: t_cajero, usuario_mod: getCurrentUser().usuario_aplicativo, est: estado
        });
        return result
    }

    async addStore(usuario, n_ide, store) {
        console.log(usuario, store, n_ide)
        const url = this.endpoint.replace(':company', getConnection()) + `/add_stores_cajero`

        const result = await this.requestsService.postLikeJSON(url, {
            usuario: usuario, tienda: store, doc: n_ide
        });
        return result

    }
    async editStore(usuario, tienda, estado) {
        const url = this.endpoint.replace(':company', getConnection()) + `/edit_stores_cajero`

        const result = await this.requestsService.putLikeJSON(url, {
            usuario: usuario, tienda: tienda, estado: estado
        });
        return result

    }
}
